import React, { createContext, useContext } from 'react';

/* ========================================================================= */
/* Context(s) */
/* ========================================================================= */

/** @type {import('$types/components/contexts').PropertyContext} */
const PropertyContext = createContext(null);

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const useProperty = () => {
    const context = useContext(PropertyContext);

    if (context === undefined) {
        throw new Error('useProperty must be used within a PropertyProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/** @type {import('$types/components/contexts').PropertyContextProvider} */
const PropertyProvider = ({ children, property }) => {
    return (
        <PropertyContext.Provider value={{ property }}>
            {children}
        </PropertyContext.Provider>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

PropertyContext.displayName = 'PropertyContext';

export {
    PropertyContext,
    PropertyProvider,
    useProperty
};
